'use client';

import { initDataDogRUM } from '@picsart/datadog-rum';

import * as packageJson from '../../package.json';

if (typeof window !== 'undefined' && process.env.NEXT_PUBLIC_DD_INIT === '1') {
  initDataDogRUM({
    initParams: {
      service: 'web-content-feeds',
      env: process.env.NEXT_PUBLIC_DATADOG_ENV,
      version: packageJson.version,
      sessionReplaySampleRate: 10,
    },
    globalContext: {
      team: 'web-xp',
    },
  });
}

export default function DatadogInit() {
  // Render nothing - this component is only included so that the init code
  // above will run client-side
  // See docs: https://docs.datadoghq.com/real_user_monitoring/guide/monitor-your-nextjs-app-with-rum/?tab=npm
  return null;
}
